import React, { useLayoutEffect, useRef, useState } from 'react';
import { clearUpdateNoticeMeasurement, setUpdateNoticeMeasurement } from './floatingTopStack';

export default function AppUpdateNotice({ onRefresh }) {
  const [refreshing, setRefreshing] = useState(false);
  const noticeRef = useRef(null);
  const measurementOwnerRef = useRef(Symbol('update-notice-measurement'));

  useLayoutEffect(() => {
    const owner = measurementOwnerRef.current;
    const syncNoticeReserve = () => {
      const height = Math.ceil(noticeRef.current?.getBoundingClientRect().height || 0);
      setUpdateNoticeMeasurement(owner, height);
    };

    syncNoticeReserve();
    const resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(syncNoticeReserve)
      : null;
    if (noticeRef.current) resizeObserver?.observe(noticeRef.current);
    window.addEventListener('resize', syncNoticeReserve);
    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener('resize', syncNoticeReserve);
      clearUpdateNoticeMeasurement(owner);
    };
  }, []);

  const refreshToLatest = () => {
    if (refreshing) return;
    // Yield one frame to the browser so the acknowledgement paints before the
    // document navigation tears down the current app.
    setRefreshing(true);
    window.setTimeout(onRefresh, 180);
  };

  return (
    <div ref={noticeRef} className={`app-update-notice ${refreshing ? 'is-refreshing' : ''}`} role="status" aria-live="polite">
      <div>
        <strong>{refreshing ? 'Refreshing Kata.fit…' : 'Kata.fit update ready'}</strong>
        <span>{refreshing ? 'Reloading with the latest fixes. This will only take a moment.' : 'Refresh when ready to use the latest fixes.'}</span>
      </div>
      <button type="button" onClick={refreshToLatest} disabled={refreshing}>
        {refreshing ? 'Refreshing…' : 'Refresh'}
      </button>
    </div>
  );
}
